import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { IDeleteLoteObraAreaChecklistUseCase } from "../../../presentation/useCases/delete/delete_lote_obra_area_checklist_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { UserFriendlyError } from "../../../../../common/utils/base_error";

/**
 * DeleteLoteObraAreaChecklistUseCase
 */

export class DeleteLoteObraAreaChecklistUseCase implements IDeleteLoteObraAreaChecklistUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteLoteObraAreaChecklist(
    rowSelection: GridRowSelectionModel | undefined,
  ): Promise<void> {
    if (rowSelection === undefined) throw new UserFriendlyError("Falha ao buscar items selecionados!");
    if (rowSelection.ids.size === 0) throw new UserFriendlyError("Falha ao buscar items selecionados!");

    await this.repository.deleteLoteObraAreaChecklist(
      Array.from(rowSelection.ids).filter((x): x is number => typeof x === 'number'));
  }
}
